import { useSetupOsNotificationSettingsFunc } from './types';

export const useSetupOsNotificationSettings: useSetupOsNotificationSettingsFunc = () =>
  undefined;
